/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Preview_CaptionInputs */

const en_mk_preview_caption = /** @type {(inputs: Mk_Preview_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Screenshots of Bystep. Choose a view to explore the workflow.`)
};

const id_mk_preview_caption = /** @type {(inputs: Mk_Preview_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tangkapan layar produk Bystep. Pilih tampilan untuk melihat alurnya.`)
};

/**
* | output |
* | --- |
* | "Screenshots of Bystep. Choose a view to explore the workflow." |
*
* @param {Mk_Preview_CaptionInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_preview_caption = /** @type {((inputs?: Mk_Preview_CaptionInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Preview_CaptionInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_preview_caption(inputs)
	return en_mk_preview_caption(inputs)
});